import { ColorProps } from '@elsevier-health/osmosis-shared';
import { useSchemeContext } from '../context/SchemeContext';

/**
 * Hook to get the colors for the current scheme
 * @returns
 */
export function useColors(): ColorProps {
  const { colors } = useSchemeContext();
  return colors;
}
